import React from 'react';
import classes from './StoreCard.module.css';
import  Button  from '../../framework/Button';

const StoreCard = ({ code, name, isOnline, url, active}) => {
  return (
    <div className={`${classes["card"]} ${isOnline ? classes["online"] : classes["offline"]}`}>
      <div className={classes["header"]}>
        <div className={classes["code"]}>{code}</div>
        <div className={`${classes["status"]} ${isOnline ? classes["statusOnline"] : classes["statusOffline"]}`}>
          {isOnline ? 'Online' : 'Offline'}
        </div>
      </div>
      <div className={classes["name"]}>{name}</div>
      {isOnline && active && (
        <div className={classes["connect"]}>
        <Button 
          onClick={() => window.open(`${url}/terminal/cac_${code?.toLowerCase()}`, '_blank')}
          label="Connect"
          color="black"
          />
        </div>
      )}
    </div>
  );
};

export default StoreCard;